module.exports = __webpack_public_path__ + "static/media/IconCopy.2570d019.svg";